import type { FaireProductEntity } from "../../entity_types/product";

export const p_9u79ht39tb: FaireProductEntity = {
  token: "p_9u79ht39tb",
  type: "product",
  name: "Sleep Lipopak",
  brandToken: "b_t43yn8tnfb",
  brandName: "Happy Aging",
  imageUrl:
    "https://cdn.faire.com/fastly/597272ef2405404dc96e4ce831f1c1e34cfa7b480078f4a4303e345de016247d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6de9d9fc14f12ff450910d481682f4fc7114d2bfd3bcdf2915c636238ba7c6d.jpeg",
    "https://cdn.faire.com/fastly/aca5d04d886585cd3d1bb3bfa2987b3982c8abb9060af117f47bfeede9826d02.jpeg",
    "https://cdn.faire.com/fastly/8b04e53e06effb112d3a5b811129a71632529d169f10ac672db17ad1a8621df0.jpeg",
    "https://cdn.faire.com/fastly/073e4541b62b7eb08eaeb7c7daf78452fdefd46fbf3340acef2ed9f4c3c304cb.png",
  ],
  priceDollars: 47,
  description:
    "Can’t drift off, yet still wake up groggy?\n\nSleep Lipopak is your bedside ally. Each vegan Lemon Vanilla sachet delivers nine synergistic nutrients in a 5×-absorbing liposomal swirl: a gentle 3 mg melatonin, magnesium bisglycinate, GABA, L-theanine, glycine, 5-HTP, lemon balm and passionflower.\n\nTogether they quiet racing thoughts, relax tense muscles and keep you asleep all night, so you rise clear-headed, not foggy. Tear, sip, lights out.\n",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:56.033Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
